import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import axios from "axios";
import Result from "./Result";
import "./Dictionary.css";
import Photos from "./Photos";

export default function Dictionary() {
  let [word, setWord] = useState("Hi");
  let [response, setResponse] = useState({});
  let [flag, setFlag] = useState(false);
  let [photos, setPhotos] = useState(null);

  function search() {
    let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${word}`;
    axios.get(apiUrl).then(handleResponse);
    let pexelsApiKey =
      "563492ad6f91700001000001fdd29f0808df42bd90c33f42e128fa89";
    let pexelsApiUrl = `https://api.pexels.com/v1/search?query=${word}&per_page=6`;
    let headers = { Authorization: `Bearer ${pexelsApiKey}` };
    axios.get(pexelsApiUrl, { headers: headers }).then(handlePexelsResponse);
  }

  function handlePexelsResponse(response) {
    setPhotos(response.data.photos);
  }
  function handleWord(event) {
    setWord(event.target.value);
  }
  function handleSubmit(event) {
    event.preventDefault();
    search();
  }
  function handleResponse(response) {
    setResponse(response.data[0]);
    console.log(response);
  }

  function load() {
    search();
    setFlag(true);
  }

  if (flag === true) {
    return (
      <div className="pt-3">
        <form className="form-section text-center" onSubmit={handleSubmit}>
          <input
            className="input-box"
            type="search"
            placeholder="Type a word"
            onChange={handleWord}
          />
        </form>
        <Result response={response} />
        <Photos photos={photos} />
        <div className="git-link text-center">
          <a
            href="https://github.com/mitramohammadi/dictionary-react"
            rel="noreferrer"
            target="_blank"
          >
            Coded By Mitra
          </a>
        </div>
      </div>
    );
  } else {
    load();
    return "Loading";
  }
}
